import { http } from '@/core/api/';

export default {
  getCompanies(properties) {
    return http.get('api/company', {
      params: {
        ...properties,
      },
    });
  },
  getSpecialists(properties) {
    return http.get(
      `api/company/${properties.companyId}/${properties.academicYearId}/specialists`,
      {
        params: {
          ...properties,
        },
      }
    );
  },
};
